module.exports = __webpack_public_path__ + "img/8.10eb42a6.svg";